import * as React from 'react'

import {
  filterIcon,
} from '../../images';


const MobileSidebarButtonContainer = ({ openMobileSidebar, }) => {
  return (
    <div className="mobile-sidebar-button-container">
      <button
        aria-expanded={false}
        className="interactive-wrapper focus-on-light"
        onClick={openMobileSidebar}
        type="button"
      >
        <img alt="" src={filterIcon.src} />
        <span className="sr-only">Show </span>Navigation
      </button>
    </div>
  )
}

export { MobileSidebarButtonContainer, }
